var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "FormFieldsContainer",
        [
          _c(
            "v-flex",
            [
              _c(
                "v-radio-group",
                {
                  attrs: { row: "" },
                  model: {
                    value: _vm.row,
                    callback: function($$v) {
                      _vm.row = $$v
                    },
                    expression: "row"
                  }
                },
                [
                  _c("v-radio", { attrs: { label: "PDF", value: "pdf" } }),
                  _c("v-radio", { attrs: { label: "Excel", value: "excel" } }),
                  _c("v-radio", { attrs: { label: "CSV", value: "csv" } }),
                  _c(
                    "v-btn",
                    {
                      on: {
                        click: function($event) {
                          return _vm.handleClick()
                        }
                      }
                    },
                    [_c("span", [_vm._v("Descargar Informe")])]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }